import { useTranslation } from "react-i18next";

import React from 'react';
import styled from 'styled-components';
import './style.scss';
import CheckIcon from './assets/checkicon.svg';
import EditIcon from './assets/editicon.svg';
import userAvatar from 'assets/images/user-avatar.jpg';
import {UserDetailsBlockProps} from './UserDetailsBlock.types';

const UserDetailsBlockWrapper = styled.div`
  background: #FFFFFF;
  box-shadow: 5px 5px 20px #EFEFEF;
  width: 100%;
  border-radius: 10px;
  position: relative;
`;

export const UserDetailsBlock :React.FC<UserDetailsBlockProps> = ({user, status}) => {
    const { t } = useTranslation();

    const calcUserAge = (birthday: any) => {
        let birth = new Date(birthday);
        var ageDifMs = Date.now() - birth.getTime();
        var ageDate = new Date(ageDifMs);
        return Math.abs(ageDate.getUTCFullYear() - 1970);
    }

    return (
        <UserDetailsBlockWrapper id={"user-details-block"}>
            {/* <button type={"button"} className={"edit-btn"}><img src={EditIcon}/></button> */}
            <div className={"user-block-head"}>
                <div className={"user-name-status justify-content-around"}>
                    <h2 className={"user-fullname"}>{user.firstName || ''} {user.lastName || ''}</h2>
                    {status == 'verified' && <span className={"user-status"}>{t("verified_tag_plain")}<img src={CheckIcon}/></span> }
                    {status !== 'verified' && <span className={"user-status-pending"}>{t("pending_tag_plain")}</span>  }
                </div>
                <img src={userAvatar}  className={"user-avatar"}/>
            </div>
            <div className={"user-info-row"} style={{ borderBottom: '1px solid #a8b2c033' }}>
                <div className={"user-info-col"} style={{ width: '60%' }}>
                    <h3 className={"col-title"}>{t("age_tag_plain")}</h3>
                    <h3 className={"col-value"}>{user.birthday ? calcUserAge(user.birthday) : ''}</h3>
                </div>
                <div className={"user-info-col"} style={{ borderLeft: '1px solid #a8b2c033', width: '40%' }}>
                    <h3 className={"col-title"}>{t("country_of_residence_tag_plain")}</h3>
                    <h3 className={"col-value"}>{user.country || ''}</h3>
                </div>
            </div>
            <div className={"user-info-row"} style={{ borderBottom: '1px solid #a8b2c033' }}>
                <div className={"user-info-col"} style={{ width: '60%' }}>
                    <h3 className={"col-title"}>{t("email_tag_plain")}</h3>
                    <h3 className={"col-value"}>{user.email || ''}</h3>
                </div>
                <div className={"user-info-col"} style={{ borderLeft: '1px solid #a8b2c033', width: '40%' }}>
                    <h3 className={"col-title"}>{t("your_address_tag_plain")}</h3>
                    <h3 className={"col-value"}>{user.address || ''}</h3>
                </div>
            </div>
            <div className={"user-info-row"} style={{ borderBottom: '1px solid #a8b2c033' }}>
                <div className={"user-info-col"} style={{ width: '60%' }}/>
                <div className={"user-info-col"} style={{ borderLeft: '1px solid #a8b2c033', width: '40%' }}>
                    <h3 className={"col-title"}>{t("phone_number_tag_plain")}</h3>
                    <h3 className={"col-value"}>{user.phone || ''}</h3>
                </div>
            </div>
        </UserDetailsBlockWrapper>
    )
};

export default UserDetailsBlock;
